<div v-if="showBtn"><Button text size="small" label="沒收到驗證碼" @click="openHint"></Button></div>